<template>
    <img class="mb-3" :src="require(`./icons/${icon}-icon.svg`)" :class="`${classString? classString : ''} icons-svg `"/>
</template>

<script>
export default {
    props:{
        icon: String,
        classString: String
    }
}
</script>
